export default __webpack_public_path__ + "media/images/mailer/logo-95ab520c2f8522efad64354fac9519ea.png";